import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormHeader } from "../../../components";
import { closeNewsViewModal, setViewNews } from "../../news/redux/actions";
import moment from "moment";
import { getLanguage } from "../../../utils/environment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import Scrollbars from "react-custom-scrollbars-2";
import { Store } from "react-notifications-component";
import { deactivateNews } from "../../news/service/news.service";

const lan = getLanguage();

const Index = (props) => {
  const { selectNews, isOpenNewsViewModal } = useSelector(
    ({ newsReducer }) => newsReducer
  );

  const dispatch = useDispatch();

  const [news, setNews] = React.useState("");
  const [newsId, setNewsId] = React.useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const getYouTubeEmbedUrl = (url) => {
    if (!url) return null;

    // Handle shortened youtu.be links
    if (url.includes("youtu.be/")) {
      return `https://www.youtube.com/embed/${url.split("youtu.be/")[1]}`;
    }

    // Handle standard youtube.com links
    if (url.includes("watch?v=")) {
      return url.replace("watch?v=", "embed/");
    }

    return url;
  };

  const onClickDeactive = async (e) => {
    setIsLoading(true);
    if (selectNews?.news_id) {
      const newStatus =
        selectNews?.status === "deactivated" ? "active" : "deactivated";
      let body = {
        status: newStatus,
      };
      console.log("Body", body);
      try {
        let result = await deactivateNews(selectNews?.news_id, body);
        if (result?.data) {
          console.log("News Status Updated successfully", result);
          setIsLoading(false);
          dispatch(closeNewsViewModal());
          Store.addNotification({
            title: "Wonderful!",
            message: `${
              newStatus === "active" ? "Activated" : "Deativated"
            } news successfully`,
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
        } else {
          console.log("News Status Updatedfailed", result);
        }
      } catch (error) {
        console.log("Error in updated news", error);
      }
    }

    setIsLoading(false);
  };

  return (
    <>
      <div
        className={`common-modal-out-bg-wrapper ${
          isOpenNewsViewModal ? "open_me" : "close__me"
        }`}
      />
      <div
        className={`common-modal-base-wrapper modal-container w-700 d-flex flex-column animate__animated  ${
          isOpenNewsViewModal ? "open_me animate__bounceIn" : "close__me"
        }`}
      >
        <div className="news_view-modal-wrapper">
          {selectNews?.youtube_url ? (
            <div class={`mb-3`}>
              <iframe
                width="100%"
                height="350"
                // src={news?.youtube_url}
                // src={news?.youtube_url.replace("watch?v=", "embed/")}
                src={getYouTubeEmbedUrl(selectNews?.youtube_url)}
                // title="${video.name}"
                title={selectNews?.title?.[lan]}
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          ) : (
            <img
              src={selectNews?.images?.[0]?.url}
              alt="news-view-img"
              className={"nv__img"}
            />
          )}

          <FormHeader
            data={{
              formHeader: selectNews?.title?.[lan],
              size: "sm-md x",
            }}
          />

          <div className="nvmw__date">
            {moment(selectNews?.created_at).format("MMMM Do YYYY, h:mm:ss a")}
          </div>
          <Scrollbars
            onScroll={handleOnScroll}
            renderView={(props) => (
              <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
            )}
            style={{ height: viewPointHeight - 700 }}
          >
            {selectNews?.content && (
              <div
                className={"nvmw__content"}
                dangerouslySetInnerHTML={{
                  __html: selectNews?.content?.[lan],
                }}
              ></div>
            )}
          </Scrollbars>
        </div>

        <div className={"nvmw_button-wrapper"}>
          <Button
            data={{
              btnName: "CLOSE",
              buttonType: "primary",
              buttonSize: "sm x",
              isLoading: false,
            }}
            onClick={async (e) => {
              dispatch(closeNewsViewModal());
            }}
          />
          <Button
            data={{
              btnName:
                selectNews?.status === "deactivated"
                  ? "ACTIVATE"
                  : "DEACTIVATE",
              buttonType: "primary",
              buttonSize: "sm x",
              isLoading: false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              await onClickDeactive(e);
            }}
          />
        </div>
      </div>
    </>
  );
};
export default withRouter(Index);
